/* 三國逗陣打 · 謀略（v0.3.0）：開戰前帶一個，F 鍵施放（類似召喚師技能）
 * 會員註冊即送「療傷」，其餘在商域用銅錢購買；訪客沒有謀略。
 * 擁有的謀略記在錢包 owned 的 'ml:<id>'（伺服器保管）；療傷不用記，會員一律擁有。 */
// @ts-nocheck — 與 sim.ts 同一套動態物件
import { SG } from './sg.ts';

const W = SG.World.prototype, K = SG.K;
const gd = (ax, ay, bx, by) => SG.gd(ax, ay, bx, by);

// aim：unit＝指定敵將、point＝指定地點、self＝自身
SG.MOULUE = [
  { id: 'heal', name: '療傷', price: 0, cd: 120, aim: 'self', desc: '回復自己與 600 內友方武將 90＋15×等級 生命，並加速 20%（1 秒）。註冊即送。' },
  { id: 'ignite', name: '毒害', price: 2000, cd: 90, aim: 'unit', range: 600, desc: '指定 600 內的敵將：5 秒內每秒 30 真實傷害，期間受到的治療 -40%。' },
  { id: 'exhaust', name: '拖延', price: 2000, cd: 120, aim: 'unit', range: 550, desc: '指定 550 內的敵將 3 秒：移速 -30%、造成的傷害 -35%。' },
  { id: 'cleanse', name: '振作', price: 2000, cd: 110, aim: 'self', desc: '立即移除身上所有控制與減益（暈眩、定身、緩速、沉默、恐懼、中毒…）。' },
  { id: 'ghost', name: '卸甲', price: 1500, cd: 120, aim: 'self', desc: '卸下重甲：6 秒內移速 +40%，但護甲 -5。' },
  { id: 'teleport', name: '支援', price: 3000, cd: 240, aim: 'point', desc: '引導 4 秒後，傳送到游標附近的友方城寨、小兵或眼旁；引導中被控制或下指令就中斷。' },
  { id: 'smite', name: '橫掃', price: 1500, cd: 45, aim: 'self', r: 300, desc: '對周圍 300 內的敵方小兵與野區黃巾賊造成 200＋10×等級 真實傷害（對黃巾賊 +15%）；對武將、塔、呂布、玉璽無效。' },
  { id: 'flash', name: '躍步', price: 3000, cd: 240, aim: 'point', range: 400, desc: '立即朝游標方向瞬移 400。' },
];
SG.ML = Object.fromEntries(SG.MOULUE.map((m) => [m.id, m]));
SG.ML_KEY = (id) => 'ml:' + id; // 錢包 owned 裡的鍵
// 會員擁有的謀略：療傷一律有，其餘看錢包
SG.mlOwned = (owned) => SG.MOULUE.filter((m) => m.id === 'heal' || (owned && owned[SG.ML_KEY(m.id)])).map((m) => m.id);
SG.ML_TP_CHANNEL = 4;
// 橫掃只打小兵（召喚物、分身不算）與野區黃巾賊；武將、建築、呂布、玉璽、糧車都不受影響
const smitable = (t) => (t.kind === 'minion' && !t.summon) || t.kind === 'creep';

// 電腦帶的謀略：依定位挑（支援需要判斷戰局，電腦不帶）
const BOT_ML = { 坦克: ['ghost', 'cleanse', 'heal'], 戰士: ['flash', 'ghost', 'ignite'], 先鋒: ['ghost', 'flash'], 刺客: ['ignite', 'flash', 'smite'], 射手: ['flash', 'heal', 'cleanse'], 法師: ['flash', 'ignite', 'cleanse'], 輔助: ['exhaust', 'heal'], 指揮: ['heal', 'exhaust', 'ghost'] };
SG.botMoulue = (spec) => { const L = BOT_ML[spec.statRole || spec.role] || ['heal']; let h = 0; for (const c of spec.id) h = (h * 31 + c.charCodeAt(0)) | 0; return L[Math.abs(h) % L.length]; }; // 同一位武將固定帶同一個

// 指定敵將：游標下或游標附近（範圍內）最近的敵將
W.mlTarget = function (u, m, x, y, tid) {
  const ok = (t) => t && t.alive && t.kind === 'hero' && this.isEnemy(u, t) && gd(u.x, u.y, t.x, t.y) <= m.range + t.r && (t.vis ? t.vis[u.team] !== false : true);
  if (tid != null) { const t = this.units.find((o) => o.id === tid); if (ok(t)) return t; }
  let best = null, bd = 1e9;
  for (const t of this.units) if (ok(t)) { const d = x == null ? gd(u.x, u.y, t.x, t.y) : gd(x, y, t.x, t.y); if (d < bd) { bd = d; best = t; } }
  return best;
};

// 施放：成功回傳 ''，否則回傳原因（不進冷卻）
W.castMoulue = function (u, q) {
  const m = SG.ML[u.ml];
  if (!m || !u.alive) return '沒有謀略';
  if (u.mlCd > 0) return `${m.name}冷卻中`;
  const s = u.st;
  if (m.id !== 'cleanse' && (s.stun > 0 || s.knockup > 0 || s.freeze > 0 || s.down > 0 || s.fear > 0 || s.charm > 0 || s.taunt > 0)) return '被控制時無法施放';
  const lv = u.lv || 1, x = q && q.x != null ? q.x : u.x + u.f * 200, y = q && q.y != null ? q.y : u.y;
  switch (m.id) {
    case 'heal': {
      for (const t of this.units) if (t.alive && t.kind === 'hero' && t.team === u.team && gd(u.x, u.y, t.x, t.y) <= 600) {
        this.heal(t, 90 + 15 * lv); t.st.msUp = Math.max(t.st.msUp, 1); t.st.msUpAmt = Math.max(t.st.msUpAmt, 0.2);
        this.fx({ k: 'heal', x: t.x, y: t.y, col: '#8fe08a' });
      }
      break;
    }
    case 'ignite': case 'exhaust': {
      const t = this.mlTarget(u, m, q && q.x, q && q.y, q && q.tid);
      if (!t) return '範圍內沒有敵將';
      if (m.id === 'ignite') { t.ign = { t: 5, tick: 1, src: u }; this.fx({ k: 'burst', x: t.x, y: t.y, col: '#9be36a' }); }
      else { t.st.weak = 3; t.st.slow = Math.max(t.st.slow, 3); t.st.slowAmt = Math.max(t.st.slowAmt, 0.3); this.fx({ k: 'burst', x: t.x, y: t.y, col: '#c9a2ff' }); }
      break;
    }
    case 'cleanse': this.mlCleanse(u); this.fx({ k: 'heal', x: u.x, y: u.y, col: '#ffffff' }); break;
    case 'ghost': u.st.msUp = Math.max(u.st.msUp, 6); u.st.msUpAmt = Math.max(u.st.msUpAmt, 0.4); u.unarmor = 6; this.fx({ k: 'puff', x: u.x, y: u.y }); break;
    case 'smite': {
      for (const t of this.enemiesNear(u, u.x, u.y, m.r)) if (smitable(t)) this.damage(u, t, (200 + 10 * lv) * (t.team === 2 ? 1.15 : 1), { pure: true, stagger: 0.2 });
      this.fx({ k: 'slam', x: u.x, y: u.y, col: '#ffd36a' });
      break;
    }
    case 'flash': {
      const dx = x - u.x, dy = (y - u.y) / K, d = Math.hypot(dx, dy) || 1, r = Math.min(m.range, d);
      const p = SG._sim.landing(u.x, u.y, u.x + dx / d * r, u.y + dy / d * r * K);
      this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = p[0]; u.y = p[1]; this.fx({ k: 'puff', x: u.x, y: u.y });
      if (u.act && u.act.kind === 'attack') this.endAct(u);
      break;
    }
    case 'teleport': {
      const t = this.mlAnchor(u, x, y);
      if (!t) return '游標附近沒有友方城寨、小兵或眼';
      u.tp = { t: SG.ML_TP_CHANNEL, to: t };
      u.input.moveTo = null; u.input.target = null; u.input.amove = null;
      if (u.act) this.endAct(u);
      break;
    }
  }
  u.mlCd = m.cd * (u.ifx && u.ifx.actCdr ? 1 - u.ifx.actCdr : 1); // 錦囊：謀略冷卻 -30%
  if (u.stat) u.stat.ml = (u.stat.ml || 0) + 1;
  if (u.human) this.dmgEvents.push({ x: u.x, y: u.y - 70, text: m.name, team: u.team, src: u.id });
  return '';
};

// 支援的落點：游標 400 內最近的友方城寨、小兵或眼
W.mlAnchor = function (u, x, y) {
  let best = null, bd = 400;
  for (const t of this.units) {
    if (!t.alive || t.team !== u.team || t === u) continue;
    if (!(t.structure || t.kind === 'minion' || t.kind === 'ward')) continue;
    const d = gd(x, y, t.x, t.y); if (d < bd) { bd = d; best = t; }
  }
  return best;
};

const CC_KEYS = ['stun', 'root', 'slow', 'fear', 'silence', 'knockup', 'down', 'freeze', 'taunt', 'charm', 'confuse', 'disarm', 'burn', 'shred', 'weak'];
W.mlCleanse = function (u) {
  for (const k of CC_KEYS) u.st[k] = 0;
  u.st.slowAmt = 0; u.st.tauntBy = null; u.st.charmBy = null;
  u.ign = null; u.dots = [];
  if (u.buffs) { u.buffs = u.buffs.filter((b) => !b.neg); SG._rebuildBuffs(u); } // 減益型 buff（技能的 debuff）
};

// 每步：冷卻、毒害、卸甲、支援引導
W.mlTick = function (u, dt) {
  if (u.mlCd > 0) u.mlCd = Math.max(0, u.mlCd - dt);
  if (u.unarmor > 0) u.unarmor = Math.max(0, u.unarmor - dt);
  if (u.ign) {
    const g = u.ign; g.t -= dt; g.tick -= dt;
    if (g.tick <= 0 && u.alive) { g.tick += 1; this.damage(g.src, u, 30, { pure: true, quiet: true, fire: false }); }
    if (g.t <= 0 || !u.alive) u.ign = null;
  }
  if (u.tp) {
    const s = u.st, I = u.input;
    const broke = !u.alive || s.stun > 0 || s.knockup > 0 || s.freeze > 0 || s.down > 0 || s.fear > 0 || s.charm > 0 || s.taunt > 0 || s.silence > 0 || I.hard || I.cancel || I.skill || !u.tp.to.alive;
    if (broke) { u.tp = null; u.mlCd = Math.min(u.mlCd, 30); if (u.human && u.alive) this.tell(u, '支援中斷', 'warn'); return; }
    u.tp.t -= dt;
    if (u.tp.t <= 0) {
      const t = u.tp.to, p = SG._sim.landing(t.x, t.y, t.x + (t.team ? -60 : 60), t.y);
      this.fx({ k: 'puff', x: u.x, y: u.y }); u.x = p[0]; u.y = p[1]; this.fx({ k: 'puff', x: u.x, y: u.y });
      u.tp = null;
    }
  }
};

// ---------- 電腦使用謀略（ai.ts 的 decide 每次思考時呼叫） ----------
SG.aiMoulue = function (w, u) {
  const m = SG.ML[u.ml];
  if (!m || u.mlCd > 0 || !u.alive || u.input.ml) return;
  const hpR = u.hp / u.maxHp, s = u.st;
  const foes = w.units.filter((t) => t.alive && t.kind === 'hero' && w.isEnemy(u, t) && gd(u.x, u.y, t.x, t.y) < 700);
  const near = (r) => foes.filter((t) => gd(u.x, u.y, t.x, t.y) <= r);
  const cast = (q) => { u.input.ml = q || {}; };
  switch (m.id) {
    case 'heal': if (hpR < 0.3 && foes.length) cast(); break;
    case 'cleanse': if ((s.stun > 0.8 || s.root > 0.8 || s.fear > 0.8 || s.charm > 0.8 || s.taunt > 0.8 || s.silence > 1.2) && foes.length) cast(); break;
    case 'ghost': if ((hpR < 0.35 && foes.length) || (u.ai && u.ai.target && u.ai.target.kind === 'hero' && u.ai.target.hp / u.ai.target.maxHp < 0.3 && gd(u.x, u.y, u.ai.target.x, u.ai.target.y) > u.range + 60)) cast(); break;
    case 'flash': {
      if (hpR < 0.2 && near(350).length) { const b = SG.MAP.bases[u.team]; cast({ x: b.x, y: b.y }); }
      break;
    }
    case 'ignite': { const t = near(m.range).find((o) => o.hp < 150 + 150 * (o.lv || 1) / 6 || o.hp / o.maxHp < 0.25); if (t) cast({ tid: t.id }); break; }
    case 'exhaust': { if (hpR < 0.6) { const t = near(m.range).sort((a, b) => b.atk - a.atk)[0]; if (t) cast({ tid: t.id }); } break; }
    case 'smite': {
      const ms = w.enemiesNear(u, u.x, u.y, m.r).filter(smitable);
      if (ms.some((t) => t.kind === 'creep' && t.hp < 220 + 10 * u.lv) || ms.filter((t) => t.kind === 'minion').length >= 4) cast(); // 搶黃巾賊尾刀，或清一波兵
      break;
    }
  }
};
